import { API_ENDPOINTS } from '../constants/api-endpoints';

export class AutoEnrollmentService {
    constructor (apiService) {
        this.apiService = apiService;
    }

    getCandidates ({ startDate, endDate }) {
        return this.apiService.get({
            path: API_ENDPOINTS.AUTO_ENROLL_CANDIDATES,
            queryParams: { startDate, endDate }
        }).then(r => r.data);
    }

    submitCourseEnrollees (courseEnrollees = []) {
        return this.apiService.post({
            path: API_ENDPOINTS.AUTO_ENROLL_ENROLLEES,
            payload: { courseEnrollees }
        }).then(r => r.data);
    }
}